import { Outlet } from 'react-router-dom';
import { CartDrawer } from '@/features/billing/CartDrawer';
import { InsufficientTokensModal } from '@/features/billing/InsufficientTokensModal';
import { Sidebar } from './Sidebar';
import { TopBar } from './TopBar';

export function AppShell() {
  return (
    <div className="flex h-screen w-screen overflow-hidden bg-[var(--surface-base)] text-[var(--text-primary)]">
      <Sidebar />
      <div className="flex flex-1 flex-col overflow-hidden">
        <TopBar />
        <main className="flex-1 overflow-auto scrollbar-thin">
          <Outlet />
        </main>
      </div>
      {/* Global modal — opens whenever the axios interceptor catches a 402. */}
      <InsufficientTokensModal />
      {/* Right-side cart drawer — opens from the CartButton in the TopBar
          (or any plan card's "Añadir al carrito"). */}
      <CartDrawer />
    </div>
  );
}
